import type { AnalyticsVersionState } from "../../../projects/hooks/useAnalyticsVersion";
import { ALL_VERSIONS } from "../constants/constants";

/** Whether the page shows one of several versions, so cards that can't follow it say so. */
export const showsOneVersion = (
  version: Pick<AnalyticsVersionState, "selected" | "hasChoice"> | undefined
) =>
  !!version?.hasChoice &&
  version.selected != null &&
  version.selected !== ALL_VERSIONS;
